import { Candidato } from "../Candidato/Candidato";
import Sala from "../ProcessoSala";
import Unidade from "../Unidade";
import { Cronograma } from "./Cronograma";
import { Edital } from "../Edital";

export enum StatusProcesso {
    CRIADO = "Criado",
    PLANEJADO = "Planejado",
    DEFINIDO = "Definido",
    FACIAL = "Facial",
    VIRTUAL = "Virtual",
    RECURSAL = "Recurso",
    FINALIZADO = "Finalizado",
    CANCELADO = "Cancelado"
}


export default interface Processo {
    id: string;
    nome: string;
    unidade: Unidade;
    identificador: string;
    responsavel: string;
    cronograma: Cronograma | null;
    salaEspera: Sala | null;
    dataCriacao: string;
    status: StatusProcesso
    candidatos: Candidato[];
    editais?: Edital[];
    numeroCandidatos?: number;
    finalizavel?: boolean; // Em relação a bancas finalizadas
    convocacoesEnviadas?: boolean;
    nomeEditavel?: boolean;
    cronogramaDefinido?: boolean;
    bancasTerminadas?: boolean;
    contasServico?: ContaServicoInfo[];
    hasIntegracaoSiga?: boolean;
    integracaoCandidatosAberta?: boolean;
    configuracaoAcessoCandidato?: {
        modo?: 'GLOBAL' | 'PROCESSO';
        janelaLiberacaoHoras?: number;
        envioFormularioRecursoPorEmail?: boolean;
        prazoInterposicaoRecursoValor?: number;
        prazoInterposicaoRecursoUnidade?: 'HORAS' | 'DIAS';
        envioAutomaticoResultadoPorEtapaHabilitado?: boolean;
    };
}

export interface ContaServicoInfo {
    descricao: string;
    unidade: Unidade;
    perfilNome?: string;
}

export class ProcessoUtils {

    static isProcessoCancelavel = (processo: Processo): boolean =>{
        if(processo.finalizavel && 
            processo.status !== StatusProcesso.CANCELADO && 
            processo.status !== StatusProcesso.FINALIZADO && 
            processo.status !== StatusProcesso.DEFINIDO &&
            processo.status === StatusProcesso.CRIADO &&
            processo.numeroCandidatos === 0)
            {
            return true;
        }
        return false;
    }

    static isProcessoFinalizavel = (processo: Processo): boolean =>{
        if(processo.finalizavel && 
            processo.status !== StatusProcesso.CANCELADO && 
            processo.status !== StatusProcesso.FINALIZADO && 
            processo.numeroCandidatos !== 0)
            {
            //console.log("FINALIZAVEL: " + processo.identificador)
            return true;
        }
        return false;
    }

    static isProcessoFinished = (processo: Processo): boolean =>{
        return (processo.status === StatusProcesso.CANCELADO || processo.status === StatusProcesso.FINALIZADO)
    }

    static getStatusColor = (status: StatusProcesso): string => {
        switch (status) {
            case StatusProcesso.CRIADO:
                return 'white';
            case StatusProcesso.PLANEJADO:
                return '#E9E2D9'; //
            case StatusProcesso.DEFINIDO:
                return '#C8AC70'; //
            case StatusProcesso.FACIAL:
                return '#D99527'; //
            case StatusProcesso.VIRTUAL:
                return '#DE743C'; // 
            case StatusProcesso.RECURSAL:
                return '#CE4B3C'; //
            case StatusProcesso.FINALIZADO:
                return '#009E49'; //
            default:
                return 'white';
        }
    };


    static getStatusExplanation = (status: StatusProcesso): string => {
        switch (status) {
            case StatusProcesso.CRIADO:
                return 'O processo foi criado recentemente e nada foi definido. Pode-se definir um Cronograma e Sala de Espera.';
            case StatusProcesso.PLANEJADO:
                return 'O processo já tem um Cronograma definido. Pode-se criar Bancas.';
            case StatusProcesso.DEFINIDO:
                return 'O processo já tem Bancas com membros definidos, pode-se convocá-las.';
            case StatusProcesso.FACIAL:
                return 'O processo já tem Banca de Identificação Facial convocada.';
            case StatusProcesso.VIRTUAL:
                return 'O processo já tem Banca de Identificação Virtual convocada.';
            case StatusProcesso.RECURSAL:
                return 'O processo já tem Banca Recursal convocada.';
            case StatusProcesso.FINALIZADO:
                return 'O processo foi finalizado.';
            case StatusProcesso.CANCELADO:
                return 'O processo foi cancelado por decisão de membro da DeDH.';
            default:
                return 'Status desconhecido.';
        }
    };

    static getStatusList(): StatusProcesso[] {
        return [
            StatusProcesso.CRIADO,
            StatusProcesso.PLANEJADO,
            StatusProcesso.DEFINIDO,
            StatusProcesso.FACIAL,
            StatusProcesso.VIRTUAL,
            StatusProcesso.RECURSAL,
            StatusProcesso.FINALIZADO,
        ];
    }

    static avancarStatus(processo: Processo): Processo {
        const statusArray = [
            StatusProcesso.CRIADO,
            StatusProcesso.PLANEJADO,
            StatusProcesso.DEFINIDO,
            StatusProcesso.FACIAL,
            StatusProcesso.VIRTUAL,
            StatusProcesso.RECURSAL,
            StatusProcesso.FINALIZADO
        ];

        const currentIndex = statusArray.indexOf(processo.status);
        if (currentIndex < statusArray.length - 1) {
            processo.status = statusArray[currentIndex + 1];
        }

        return processo;
    }

    static isStatusIgualOuPosterior(status: StatusProcesso, statusAtual: StatusProcesso): boolean {
        const statusArray = [
            StatusProcesso.CRIADO,
            StatusProcesso.PLANEJADO,
            StatusProcesso.DEFINIDO,
            StatusProcesso.FACIAL,
            StatusProcesso.VIRTUAL,
            StatusProcesso.RECURSAL,
            StatusProcesso.FINALIZADO
        ];

        return statusArray.indexOf(statusAtual) >= statusArray.indexOf(status);
    }

    static getStatusByIndex(index: number): StatusProcesso | null {
        const statusArray = [
            StatusProcesso.CRIADO,
            StatusProcesso.PLANEJADO,
            StatusProcesso.DEFINIDO,
            StatusProcesso.FACIAL,
            StatusProcesso.VIRTUAL,
            StatusProcesso.RECURSAL,
            StatusProcesso.FINALIZADO
        ];
        return statusArray[index] || null;
    }

    static getidentificadorDeStatus(): number {
        const statusArray = [
            StatusProcesso.CRIADO,
            StatusProcesso.PLANEJADO,
            StatusProcesso.DEFINIDO,
            StatusProcesso.FACIAL,
            StatusProcesso.VIRTUAL,
            StatusProcesso.RECURSAL,
            StatusProcesso.FINALIZADO
        ];
        return statusArray.length;
    }

    static getStatusKeyByValue(value: string): StatusProcesso | null {
        const statusKey = Object.entries(StatusProcesso).find(([_, enumValue]) => enumValue === value);
        return statusKey ? (statusKey[0] as StatusProcesso) : null;
    }

}
